<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-20 15:32:31
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-20 17:07:11
 * @Description: 大喇叭
-->
<template>
  <div class="home-loud-speaker">
    <!-- 首页功能模块共用组件 -->
    <func-module
      title="大喇叭"
      icon="icon-laba"
      titleColor="#f3a954"
      rowColor="#fcead2"
      publishColor="#f3a954"
      hoverColor="#c48a43"
      :listData="data.list"
      :tips="loudSpeakerTips"
      @intoDetail="loudSpeakerListPre"
      @hanleViewAll="getAllLoudSpeakerData"
      @handlePublish="handlePublish"
    >
      <template #row="{item}">
        <div class="row">
          <div class="row-left">
            {{ item.postTitle }}
          </div>
          <div class="row-right">
            <span class="name">{{ item.userName }}</span>
            <span class="time">{{ item.createTm | dateFormat }}</span>
          </div>
        </div>
      </template>
    </func-module>

    <animation
      :loadingDataVisible="
        !attachmentUploadState || !formInfoSaveState || data.isLoading
      "
      :loadingText="loadingText"
    ></animation>

    <post-detail
      v-if="postDetailVisible"
      @handlerVisible="handlerVisible"
      :baseUrl="baseUrlDetail"
      :post-code="dialog.postCode"
    />

    <post-create
      title="发布大喇叭文章"
      :tips="loudSpeakerTips"
      @sensitiveWord="sensitiveWord"
      :visible.sync="postCreateVisible"
      @handlerVisible="handlerVisible"
      :baseUrl="baseUrl"
      @refresh="queryData"
    />
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import animation from "@/components/loading/animation";
import PostDetail from "../detail/PostDetail";
import PostCreate from "../detail/PostCreate";
import FuncModule from "@/components/common/FuncModule";
import { mapState } from "vuex";
export default {
  name: "LoudSpeakerComponent",
  components: { PostCreate, PostDetail, animation, FuncModule },
  data() {
    return {
      systemPower: false,
      superPower: false,
      this_: this,
      //true是结束,false是正在处理
      attachmentUploadState: true,
      //true是结束,false是正在处理
      formInfoSaveState: true,
      loadingText: null,
      data: {
        list: [],
        isLoading: false,
        pageNum: 1,
        pageSize: 6
      },
      dialog: {
        isShow: false,
        postCode: null,
        editFlag: "view"
      },
      postCreateVisible: false,
      postDetailVisible: false,
      //大喇叭的基础路径
      baseUrlDetail: "/eims-api/loudSpeaker/detail",
      //大喇叭的基础路径
      baseUrl: "/eims-api/loudSpeaker/create"
    };
  },

  watch: {},

  computed: {},

  created() {
    this.queryData();
  },
  methods: {
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    },

    handlerVisible(flag) {
      this.postDetailVisible = flag;
      this.postCreateVisible = flag;
    },
    getAllLoudSpeakerData() {
      this.$router.push({ path: "/article/LoudSpeakerlist" });
    },
    handlePublish() {
      this.postCreateVisible = true;
    },
    loudSpeakerListPre(row) {
      this.postDetailVisible = true;
      this.border = true;
      this.dialog.editFlag = "view";
      this.dialog.isShow = true;
      this.dialog.postCode = row.postCode;
    },

    closeDialog() {
      this.dialog.isShow = false;
      this.dialog.editFlag = "view";
      this.dialog.postCode = null;
      this.queryData();
    },
    queryData() {
      this.data.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/loudSpeaker/list", {
          token: cookie.getCookie("token"),
          data: {
            pageNum: this.data.pageNum,
            pageSize: this.data.pageSize
          }
        })
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total;
          }
        })
        .finally(() => {
          this.loadingDataVisible = false;
          this.data.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-loud-speaker {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  width: 100%;
  font-family: SourceHanSansSC;
  .row {
    display: flex;
    justify-content: space-between;
    .row-left {
      // width: calc(100% - min(35%, 160px));
      width: 70%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 5px;
      font-size: 18px;
      font-weight: bold;
    }
    .row-right {
      display: flex;
      justify-content: space-between;
      // width: calc(min(35%, 180px));
      width: 30%;
      color: rgb(153, 153, 153);
      line-height: 20px;
      .name {
        width: calc(100% / 3);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .time {
        margin: 0 10px;
        width: calc(100% / 3 * 2);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/LoudSpeakerComponent.vue